/**
 * 爆款模板图片上传统一校验规则（前端固定，不依赖后端返回）
 */
export const VIRAL_TEMPLATE_IMAGE_UPLOAD_ACCEPT = '.png,.jpg,.jpeg';

export const VIRAL_TEMPLATE_IMAGE_UPLOAD_RULES = {
  minWidth: 300,
  minHeight: 300,
  maxWidth: 2560,
  maxHeight: 2560,
  maxSizeBytes: 10 * 1024 * 1024,
  minAspectRatio: 1 / 2.5,
  maxAspectRatio: 2.5,
  minAspectRatioText: '1:2.5',
  maxAspectRatioText: '2.5:1',
} as const;

export function isSupportedViralTemplateImageType(file: File): boolean {
  const fileType = (file.type || '').toLowerCase();
  if (fileType === 'image/png' || fileType === 'image/jpeg' || fileType === 'image/jpg') {
    return true;
  }
  const fileName = (file.name || '').toLowerCase();
  return (
    fileName.endsWith('.png') || fileName.endsWith('.jpg') || fileName.endsWith('.jpeg')
  );
}
